export default __webpack_public_path__ + "static/media/cxqqrss.2ea2388f.svg";